import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import HelmetWrapper from 'components/HelmetWrapper';
import QAndAPaginatedContainer from '../../../../components/QAndAPaginatedContainer';
import DataRoomContext from '../../../../providers/DataRoom/DataRoom.context';
import { Navigate } from 'react-router-dom';
import { getDataRoomRoute } from 'utils';

import './QuestionsAndAnswers.styles.scss';

type QuestionsAndAnswersProps = {
  className?: string;
};

const QuestionsAndAnswers: React.FC<QuestionsAndAnswersProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();

  const {
    doesUserHaveAccessToQa,
    dataRoom: { _id, name },
  } = useContext(DataRoomContext);

  const classes = classNames('questions-and-answers', className);

  if (!doesUserHaveAccessToQa)
    return <Navigate to={getDataRoomRoute(_id, 'documents')} replace />;

  return (
    <div className={classes}>
      <HelmetWrapper title={`${t('qAndA')} - ${name}`} />
      <QAndAPaginatedContainer />
    </div>
  );
};

export default QuestionsAndAnswers;
